import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import ArchivationReasonSelect from './ArchivationReasonSelect';

const ArchivationReasonSelectField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<ArchivationReasonSelect />
	</BaseField>
);

export default ArchivationReasonSelectField;
